import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from '@lockton-apps/material';

import { Cab } from './cab/cab.component';
import { IconButton } from './icon-button/icon-button.component';
import { Button } from './standard-button/button.component';
import { TextButton } from './text-button/text-button.component';
import { Fab } from './fab/fab.component';
import { CircularProgressModule } from '../circular-progress';

const publicApi = [Button, Cab, IconButton, TextButton, Fab];

@NgModule({
  imports: [CommonModule, MaterialModule, CircularProgressModule],
  declarations: [...publicApi],
  exports: [...publicApi],
})
export class ButtonModule {}
